// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","FilterForm__hgroup":"ot_a bia_a bia_x","FilterForm__vgroup":"ot_b bia_sv"};